import { easings } from '@ui/css';
import { makeTransitionToken } from '@utils/css';

const headerCollapse = makeTransitionToken("--header--collapse", {
  defaultDurationMs: 250,
  properties: {
    transform: {
      easing: easings.inOutQuad
    }
  }
});
const asideCollapse = makeTransitionToken("--aside--collapse", {
  defaultDurationMs: 250,
  properties: {
    transform: {
      easing: easings.outQuad
    },
    opacity: {
      easing: "linear"
    }
  }
});

export { asideCollapse, headerCollapse };
//# sourceMappingURL=transitions.js.map
